// Traductions Postinity — toasts (messages transitoires) LivingCandle.
const fr = {
  tt_cam_denied: "Accès caméra refusé ou indisponible",
  tt_add_guarantor: "Ajoutez d'abord au moins une personne garante dans l'étape Publication.",
  tt_no_video: "Aucune vidéo n'a été captée. Autorisez la caméra et le micro, puis réessayez (ou importez un fichier vidéo).",
  tt_copy_fail: "Copie impossible",
  tt_cer_saved_full: "Cérémonie enregistrée ✓ (texte, chansons, photos, musique)",
  tt_cer_saved: "Cérémonie enregistrée ✓",
  tt_dossier_unlocked: "Dossier débloqué 🎉",
  tt_cam_unsupported: "Enregistrement caméra non supporté par ce navigateur",
  tt_save_fail: "Enregistrement impossible",
  tt_save_msg_first: "Enregistrez d'abord le message",
  tt_saved: "Enregistré",
  tt_mp3_mp4: "Fichier MP3 ou MP4 requis",
  tt_file_deleted: "Fichier supprimé",
  tt_file_too_big20: "Fichier trop volumineux (max 20 Mo)",
  tt_video_required: "Fichier vidéo requis",
  tt_files_saved: "Fichier(s) enregistré(s) 📎",
  tt_unavailable: "Fonctionnalité non disponible pour le moment.",
  tt_garants_off: "Garants désactivés",
  tt_image_required: "Image requise",
  tt_import_fail: "Import impossible",
  tt_import_photo_fail: "Import photo impossible",
  tt_email_first: "Indiquez d'abord l'e-mail du destinataire",
  tt_email_indicate: "Indiquez l'e-mail du destinataire",
  tt_link_dossier: "Lien du dossier copié",
  tt_link_msg: "Lien du message copié",
  tt_link_garant: "Lien garant copié",
  tt_msg_deleted: "Message supprimé",
  tt_music_added: "Musique ajoutée 🎵",
  tt_msg_music_saved: "Musique du message enregistrée 🎵",
  tt_music_deleted: "Musique supprimée",
  tt_music_too_big: "Musique trop lourde (max 20 Mo)",
  tt_open_fail: "Ouverture impossible",
  tt_photo_saved: "Photo enregistrée",
  tt_photo_too_big: "Photo trop lourde (max 3 Mo)",
  tt_delete_fail: "Suppression impossible",
  tt_cer_video_saved: "Vidéo de cérémonie enregistrée 🎬",
  tt_msg_video_saved: "Vidéo du message enregistrée 🎬",
  tt_video_saved_e: "Vidéo enregistrée 🎬",
  tt_video_deleted: "Vidéo supprimée",
  tt_video_too_big: "Vidéo trop volumineuse (max 200 Mo)",
  tt_vault: "Vos données sont enregistrées dans votre coffre-fort numérique, modifiable à tout moment.",
  tt_action_fail: "Action impossible",
};
const en = {
  tt_cam_denied: "Camera access denied or unavailable",
  tt_add_guarantor: "First add at least one guardian in the Publication step.",
  tt_no_video: "No video was captured. Allow camera and microphone, then try again (or import a video file).",
  tt_copy_fail: "Copy failed",
  tt_cer_saved_full: "Ceremony saved ✓ (text, songs, photos, music)",
  tt_cer_saved: "Ceremony saved ✓",
  tt_dossier_unlocked: "File unlocked 🎉",
  tt_cam_unsupported: "Camera recording not supported by this browser",
  tt_save_fail: "Could not save",
  tt_save_msg_first: "Save the message first",
  tt_saved: "Saved",
  tt_mp3_mp4: "MP3 or MP4 file required",
  tt_file_deleted: "File deleted",
  tt_file_too_big20: "File too large (max 20 MB)",
  tt_video_required: "Video file required",
  tt_files_saved: "File(s) saved 📎",
  tt_unavailable: "Feature not available at the moment.",
  tt_garants_off: "Guardians deactivated",
  tt_image_required: "Image required",
  tt_import_fail: "Import failed",
  tt_import_photo_fail: "Photo import failed",
  tt_email_first: "First enter the recipient's email",
  tt_email_indicate: "Enter the recipient's email",
  tt_link_dossier: "File link copied",
  tt_link_msg: "Message link copied",
  tt_link_garant: "Guardian link copied",
  tt_msg_deleted: "Message deleted",
  tt_music_added: "Music added 🎵",
  tt_msg_music_saved: "Message music saved 🎵",
  tt_music_deleted: "Music deleted",
  tt_music_too_big: "Music too large (max 20 MB)",
  tt_open_fail: "Could not open",
  tt_photo_saved: "Photo saved",
  tt_photo_too_big: "Photo too large (max 3 MB)",
  tt_delete_fail: "Could not delete",
  tt_cer_video_saved: "Ceremony video saved 🎬",
  tt_msg_video_saved: "Message video saved 🎬",
  tt_video_saved_e: "Video saved 🎬",
  tt_video_deleted: "Video deleted",
  tt_video_too_big: "Video too large (max 200 MB)",
  tt_vault: "Your data is saved in your digital vault, editable at any time.",
  tt_action_fail: "Action failed",
};
const es = {
  tt_cam_denied: "Acceso a la cámara denegado o no disponible",
  tt_add_guarantor: "Añade primero al menos un garante en la etapa Publicación.",
  tt_no_video: "No se capturó ningún vídeo. Permite la cámara y el micrófono e inténtalo de nuevo (o importa un archivo de vídeo).",
  tt_copy_fail: "No se pudo copiar",
  tt_cer_saved_full: "Ceremonia guardada ✓ (texto, canciones, fotos, música)",
  tt_cer_saved: "Ceremonia guardada ✓",
  tt_dossier_unlocked: "Expediente desbloqueado 🎉",
  tt_cam_unsupported: "Este navegador no admite grabación con cámara",
  tt_save_fail: "No se pudo guardar",
  tt_save_msg_first: "Guarda primero el mensaje",
  tt_saved: "Guardado",
  tt_mp3_mp4: "Se requiere archivo MP3 o MP4",
  tt_file_deleted: "Archivo eliminado",
  tt_file_too_big20: "Archivo demasiado grande (máx. 20 MB)",
  tt_video_required: "Se requiere archivo de vídeo",
  tt_files_saved: "Archivo(s) guardado(s) 📎",
  tt_unavailable: "Función no disponible por el momento.",
  tt_garants_off: "Garantes desactivados",
  tt_image_required: "Se requiere imagen",
  tt_import_fail: "No se pudo importar",
  tt_import_photo_fail: "No se pudo importar la foto",
  tt_email_first: "Indica primero el correo del destinatario",
  tt_email_indicate: "Indica el correo del destinatario",
  tt_link_dossier: "Enlace del expediente copiado",
  tt_link_msg: "Enlace del mensaje copiado",
  tt_link_garant: "Enlace del garante copiado",
  tt_msg_deleted: "Mensaje eliminado",
  tt_music_added: "Música añadida 🎵",
  tt_msg_music_saved: "Música del mensaje guardada 🎵",
  tt_music_deleted: "Música eliminada",
  tt_music_too_big: "Música demasiado grande (máx. 20 MB)",
  tt_open_fail: "No se pudo abrir",
  tt_photo_saved: "Foto guardada",
  tt_photo_too_big: "Foto demasiado grande (máx. 3 MB)",
  tt_delete_fail: "No se pudo eliminar",
  tt_cer_video_saved: "Vídeo de la ceremonia guardado 🎬",
  tt_msg_video_saved: "Vídeo del mensaje guardado 🎬",
  tt_video_saved_e: "Vídeo guardado 🎬",
  tt_video_deleted: "Vídeo eliminado",
  tt_video_too_big: "Vídeo demasiado grande (máx. 200 MB)",
  tt_vault: "Tus datos se guardan en tu caja fuerte digital, modificable en cualquier momento.",
  tt_action_fail: "Acción imposible",
};
const de = {
  tt_cam_denied: "Kamerazugriff verweigert oder nicht verfügbar",
  tt_add_guarantor: "Fügen Sie zuerst mindestens einen Bürgen im Schritt Veröffentlichung hinzu.",
  tt_no_video: "Es wurde kein Video aufgenommen. Erlauben Sie Kamera und Mikrofon und versuchen Sie es erneut (oder importieren Sie eine Videodatei).",
  tt_copy_fail: "Kopieren fehlgeschlagen",
  tt_cer_saved_full: "Zeremonie gespeichert ✓ (Text, Lieder, Fotos, Musik)",
  tt_cer_saved: "Zeremonie gespeichert ✓",
  tt_dossier_unlocked: "Datei freigeschaltet 🎉",
  tt_cam_unsupported: "Kameraaufnahme von diesem Browser nicht unterstützt",
  tt_save_fail: "Speichern fehlgeschlagen",
  tt_save_msg_first: "Speichern Sie zuerst die Nachricht",
  tt_saved: "Gespeichert",
  tt_mp3_mp4: "MP3- oder MP4-Datei erforderlich",
  tt_file_deleted: "Datei gelöscht",
  tt_file_too_big20: "Datei zu groß (max. 20 MB)",
  tt_video_required: "Videodatei erforderlich",
  tt_files_saved: "Datei(en) gespeichert 📎",
  tt_unavailable: "Funktion momentan nicht verfügbar.",
  tt_garants_off: "Bürgen deaktiviert",
  tt_image_required: "Bild erforderlich",
  tt_import_fail: "Import fehlgeschlagen",
  tt_import_photo_fail: "Fotoimport fehlgeschlagen",
  tt_email_first: "Geben Sie zuerst die E-Mail des Empfängers ein",
  tt_email_indicate: "Geben Sie die E-Mail des Empfängers ein",
  tt_link_dossier: "Dateilink kopiert",
  tt_link_msg: "Nachrichtenlink kopiert",
  tt_link_garant: "Bürgenlink kopiert",
  tt_msg_deleted: "Nachricht gelöscht",
  tt_music_added: "Musik hinzugefügt 🎵",
  tt_msg_music_saved: "Nachrichtenmusik gespeichert 🎵",
  tt_music_deleted: "Musik gelöscht",
  tt_music_too_big: "Musik zu groß (max. 20 MB)",
  tt_open_fail: "Öffnen fehlgeschlagen",
  tt_photo_saved: "Foto gespeichert",
  tt_photo_too_big: "Foto zu groß (max. 3 MB)",
  tt_delete_fail: "Löschen fehlgeschlagen",
  tt_cer_video_saved: "Zeremonievideo gespeichert 🎬",
  tt_msg_video_saved: "Nachrichtenvideo gespeichert 🎬",
  tt_video_saved_e: "Video gespeichert 🎬",
  tt_video_deleted: "Video gelöscht",
  tt_video_too_big: "Video zu groß (max. 200 MB)",
  tt_vault: "Ihre Daten werden in Ihrem digitalen Safe gespeichert, jederzeit änderbar.",
  tt_action_fail: "Aktion fehlgeschlagen",
};
const it = {
  tt_cam_denied: "Accesso alla fotocamera negato o non disponibile",
  tt_add_guarantor: "Aggiungi prima almeno un garante nella fase Pubblicazione.",
  tt_no_video: "Nessun video acquisito. Consenti fotocamera e microfono e riprova (o importa un file video).",
  tt_copy_fail: "Copia non riuscita",
  tt_cer_saved_full: "Cerimonia salvata ✓ (testo, canzoni, foto, musica)",
  tt_cer_saved: "Cerimonia salvata ✓",
  tt_dossier_unlocked: "Dossier sbloccato 🎉",
  tt_cam_unsupported: "Registrazione con fotocamera non supportata da questo browser",
  tt_save_fail: "Salvataggio non riuscito",
  tt_save_msg_first: "Salva prima il messaggio",
  tt_saved: "Salvato",
  tt_mp3_mp4: "È richiesto un file MP3 o MP4",
  tt_file_deleted: "File eliminato",
  tt_file_too_big20: "File troppo grande (max 20 MB)",
  tt_video_required: "È richiesto un file video",
  tt_files_saved: "File salvato/i 📎",
  tt_unavailable: "Funzione non disponibile al momento.",
  tt_garants_off: "Garanti disattivati",
  tt_image_required: "È richiesta un'immagine",
  tt_import_fail: "Importazione non riuscita",
  tt_import_photo_fail: "Importazione foto non riuscita",
  tt_email_first: "Inserisci prima l'email del destinatario",
  tt_email_indicate: "Inserisci l'email del destinatario",
  tt_link_dossier: "Link del dossier copiato",
  tt_link_msg: "Link del messaggio copiato",
  tt_link_garant: "Link garante copiato",
  tt_msg_deleted: "Messaggio eliminato",
  tt_music_added: "Musica aggiunta 🎵",
  tt_msg_music_saved: "Musica del messaggio salvata 🎵",
  tt_music_deleted: "Musica eliminata",
  tt_music_too_big: "Musica troppo grande (max 20 MB)",
  tt_open_fail: "Apertura non riuscita",
  tt_photo_saved: "Foto salvata",
  tt_photo_too_big: "Foto troppo grande (max 3 MB)",
  tt_delete_fail: "Eliminazione non riuscita",
  tt_cer_video_saved: "Video della cerimonia salvato 🎬",
  tt_msg_video_saved: "Video del messaggio salvato 🎬",
  tt_video_saved_e: "Video salvato 🎬",
  tt_video_deleted: "Video eliminato",
  tt_video_too_big: "Video troppo grande (max 200 MB)",
  tt_vault: "I tuoi dati sono salvati nella tua cassaforte digitale, modificabile in qualsiasi momento.",
  tt_action_fail: "Azione non riuscita",
};
const pl = {
  tt_cam_denied: "Odmowa dostępu do kamery lub niedostępna",
  tt_add_guarantor: "Najpierw dodaj co najmniej jednego gwaranta w kroku Publikacja.",
  tt_no_video: "Nie nagrano wideo. Zezwól na kamerę i mikrofon, a następnie spróbuj ponownie (lub zaimportuj plik wideo).",
  tt_copy_fail: "Nie udało się skopiować",
  tt_cer_saved_full: "Ceremonia zapisana ✓ (tekst, piosenki, zdjęcia, muzyka)",
  tt_cer_saved: "Ceremonia zapisana ✓",
  tt_dossier_unlocked: "Odblokowano 🎉",
  tt_cam_unsupported: "Ta przeglądarka nie obsługuje nagrywania kamerą",
  tt_save_fail: "Nie udało się zapisać",
  tt_save_msg_first: "Najpierw zapisz wiadomość",
  tt_saved: "Zapisano",
  tt_mp3_mp4: "Wymagany plik MP3 lub MP4",
  tt_file_deleted: "Plik usunięty",
  tt_file_too_big20: "Plik za duży (maks. 20 MB)",
  tt_video_required: "Wymagany plik wideo",
  tt_files_saved: "Plik(i) zapisane 📎",
  tt_unavailable: "Funkcja obecnie niedostępna.",
  tt_garants_off: "Gwaranci dezaktywowani",
  tt_image_required: "Wymagany obraz",
  tt_import_fail: "Import nie powiódł się",
  tt_import_photo_fail: "Nie udało się zaimportować zdjęcia",
  tt_email_first: "Najpierw podaj e-mail odbiorcy",
  tt_email_indicate: "Podaj e-mail odbiorcy",
  tt_link_dossier: "Skopiowano link dossier",
  tt_link_msg: "Skopiowano link wiadomości",
  tt_link_garant: "Skopiowano link gwaranta",
  tt_msg_deleted: "Wiadomość usunięta",
  tt_music_added: "Dodano muzykę 🎵",
  tt_msg_music_saved: "Zapisano muzykę wiadomości 🎵",
  tt_music_deleted: "Muzyka usunięta",
  tt_music_too_big: "Muzyka za duża (maks. 20 MB)",
  tt_open_fail: "Nie udało się otworzyć",
  tt_photo_saved: "Zdjęcie zapisane",
  tt_photo_too_big: "Zdjęcie za duże (maks. 3 MB)",
  tt_delete_fail: "Nie udało się usunąć",
  tt_cer_video_saved: "Zapisano wideo ceremonii 🎬",
  tt_msg_video_saved: "Zapisano wideo wiadomości 🎬",
  tt_video_saved_e: "Wideo zapisane 🎬",
  tt_video_deleted: "Wideo usunięte",
  tt_video_too_big: "Wideo za duże (maks. 200 MB)",
  tt_vault: "Twoje dane są zapisane w cyfrowym sejfie, zmienialne w każdej chwili.",
  tt_action_fail: "Nie udało się wykonać",
};
const fil = {
  tt_cam_denied: "Tinanggihan o hindi available ang camera",
  tt_add_guarantor: "Magdagdag muna ng kahit isang tagapangalaga sa hakbang na Paglalathala.",
  tt_no_video: "Walang na-capture na video. Payagan ang camera at mikropono, pagkatapos subukan muli (o mag-import ng video file).",
  tt_copy_fail: "Hindi makopya",
  tt_cer_saved_full: "Na-save ang seremonya ✓ (teksto, kanta, larawan, musika)",
  tt_cer_saved: "Na-save ang seremonya ✓",
  tt_dossier_unlocked: "Na-unlock ang file 🎉",
  tt_cam_unsupported: "Hindi sinusuportahan ng browser na ito ang pag-record ng camera",
  tt_save_fail: "Hindi ma-save",
  tt_save_msg_first: "I-save muna ang mensahe",
  tt_saved: "Na-save",
  tt_mp3_mp4: "Kailangan ng MP3 o MP4 file",
  tt_file_deleted: "Nabura ang file",
  tt_file_too_big20: "Masyadong malaki ang file (max 20 MB)",
  tt_video_required: "Kailangan ng video file",
  tt_files_saved: "Na-save ang file 📎",
  tt_unavailable: "Hindi available ang feature sa ngayon.",
  tt_garants_off: "Na-deactivate ang mga tagapangalaga",
  tt_image_required: "Kailangan ng larawan",
  tt_import_fail: "Hindi ma-import",
  tt_import_photo_fail: "Hindi ma-import ang larawan",
  tt_email_first: "Ilagay muna ang email ng tatanggap",
  tt_email_indicate: "Ilagay ang email ng tatanggap",
  tt_link_dossier: "Nakopya ang link ng file",
  tt_link_msg: "Nakopya ang link ng mensahe",
  tt_link_garant: "Nakopya ang link ng tagapangalaga",
  tt_msg_deleted: "Nabura ang mensahe",
  tt_music_added: "Naidagdag ang musika 🎵",
  tt_msg_music_saved: "Na-save ang musika ng mensahe 🎵",
  tt_music_deleted: "Nabura ang musika",
  tt_music_too_big: "Masyadong malaki ang musika (max 20 MB)",
  tt_open_fail: "Hindi mabuksan",
  tt_photo_saved: "Na-save ang larawan",
  tt_photo_too_big: "Masyadong malaki ang larawan (max 3 MB)",
  tt_delete_fail: "Hindi mabura",
  tt_cer_video_saved: "Na-save ang video ng seremonya 🎬",
  tt_msg_video_saved: "Na-save ang video ng mensahe 🎬",
  tt_video_saved_e: "Na-save ang video 🎬",
  tt_video_deleted: "Nabura ang video",
  tt_video_too_big: "Masyadong malaki ang video (max 200 MB)",
  tt_vault: "Naka-save ang iyong data sa digital vault, mababago anumang oras.",
  tt_action_fail: "Hindi maisagawa",
};
const ru = {
  tt_cam_denied: "Доступ к камере запрещён или недоступен",
  tt_add_guarantor: "Сначала добавьте хотя бы одного поручителя на этапе Публикация.",
  tt_no_video: "Видео не записано. Разрешите камеру и микрофон и повторите (или импортируйте видеофайл).",
  tt_copy_fail: "Не удалось скопировать",
  tt_cer_saved_full: "Церемония сохранена ✓ (текст, песни, фото, музыка)",
  tt_cer_saved: "Церемония сохранена ✓",
  tt_dossier_unlocked: "Досье разблокировано 🎉",
  tt_cam_unsupported: "Запись с камеры не поддерживается этим браузером",
  tt_save_fail: "Не удалось сохранить",
  tt_save_msg_first: "Сначала сохраните послание",
  tt_saved: "Сохранено",
  tt_mp3_mp4: "Требуется файл MP3 или MP4",
  tt_file_deleted: "Файл удалён",
  tt_file_too_big20: "Файл слишком большой (макс. 20 МБ)",
  tt_video_required: "Требуется видеофайл",
  tt_files_saved: "Файл(ы) сохранены 📎",
  tt_unavailable: "Функция сейчас недоступна.",
  tt_garants_off: "Поручители деактивированы",
  tt_image_required: "Требуется изображение",
  tt_import_fail: "Не удалось импортировать",
  tt_import_photo_fail: "Не удалось импортировать фото",
  tt_email_first: "Сначала укажите e-mail получателя",
  tt_email_indicate: "Укажите e-mail получателя",
  tt_link_dossier: "Ссылка досье скопирована",
  tt_link_msg: "Ссылка послания скопирована",
  tt_link_garant: "Ссылка поручителя скопирована",
  tt_msg_deleted: "Послание удалено",
  tt_music_added: "Музыка добавлена 🎵",
  tt_msg_music_saved: "Музыка послания сохранена 🎵",
  tt_music_deleted: "Музыка удалена",
  tt_music_too_big: "Музыка слишком большая (макс. 20 МБ)",
  tt_open_fail: "Не удалось открыть",
  tt_photo_saved: "Фото сохранено",
  tt_photo_too_big: "Фото слишком большое (макс. 3 МБ)",
  tt_delete_fail: "Не удалось удалить",
  tt_cer_video_saved: "Видео церемонии сохранено 🎬",
  tt_msg_video_saved: "Видео послания сохранено 🎬",
  tt_video_saved_e: "Видео сохранено 🎬",
  tt_video_deleted: "Видео удалено",
  tt_video_too_big: "Видео слишком большое (макс. 200 МБ)",
  tt_vault: "Ваши данные сохранены в цифровом сейфе, изменяемы в любой момент.",
  tt_action_fail: "Действие невозможно",
};
const el = {
  tt_cam_denied: "Άρνηση ή μη διαθεσιμότητα πρόσβασης κάμερας",
  tt_add_guarantor: "Προσθέστε πρώτα τουλάχιστον έναν εγγυητή στο βήμα Δημοσίευση.",
  tt_no_video: "Δεν καταγράφηκε βίντεο. Επιτρέψτε κάμερα και μικρόφωνο και δοκιμάστε ξανά (ή εισαγάγετε αρχείο βίντεο).",
  tt_copy_fail: "Η αντιγραφή απέτυχε",
  tt_cer_saved_full: "Η τελετή αποθηκεύτηκε ✓ (κείμενο, τραγούδια, φωτογραφίες, μουσική)",
  tt_cer_saved: "Η τελετή αποθηκεύτηκε ✓",
  tt_dossier_unlocked: "Ο φάκελος ξεκλειδώθηκε 🎉",
  tt_cam_unsupported: "Η εγγραφή κάμερας δεν υποστηρίζεται από αυτό το πρόγραμμα περιήγησης",
  tt_save_fail: "Η αποθήκευση απέτυχε",
  tt_save_msg_first: "Αποθηκεύστε πρώτα το μήνυμα",
  tt_saved: "Αποθηκεύτηκε",
  tt_mp3_mp4: "Απαιτείται αρχείο MP3 ή MP4",
  tt_file_deleted: "Το αρχείο διαγράφηκε",
  tt_file_too_big20: "Πολύ μεγάλο αρχείο (μέγ. 20 MB)",
  tt_video_required: "Απαιτείται αρχείο βίντεο",
  tt_files_saved: "Το/Τα αρχείο(α) αποθηκεύτηκαν 📎",
  tt_unavailable: "Η λειτουργία δεν είναι διαθέσιμη προς το παρόν.",
  tt_garants_off: "Οι εγγυητές απενεργοποιήθηκαν",
  tt_image_required: "Απαιτείται εικόνα",
  tt_import_fail: "Η εισαγωγή απέτυχε",
  tt_import_photo_fail: "Η εισαγωγή φωτογραφίας απέτυχε",
  tt_email_first: "Δώστε πρώτα το email του παραλήπτη",
  tt_email_indicate: "Δώστε το email του παραλήπτη",
  tt_link_dossier: "Ο σύνδεσμος φακέλου αντιγράφηκε",
  tt_link_msg: "Ο σύνδεσμος μηνύματος αντιγράφηκε",
  tt_link_garant: "Ο σύνδεσμος εγγυητή αντιγράφηκε",
  tt_msg_deleted: "Το μήνυμα διαγράφηκε",
  tt_music_added: "Προστέθηκε μουσική 🎵",
  tt_msg_music_saved: "Η μουσική του μηνύματος αποθηκεύτηκε 🎵",
  tt_music_deleted: "Η μουσική διαγράφηκε",
  tt_music_too_big: "Πολύ μεγάλη μουσική (μέγ. 20 MB)",
  tt_open_fail: "Το άνοιγμα απέτυχε",
  tt_photo_saved: "Η φωτογραφία αποθηκεύτηκε",
  tt_photo_too_big: "Πολύ μεγάλη φωτογραφία (μέγ. 3 MB)",
  tt_delete_fail: "Η διαγραφή απέτυχε",
  tt_cer_video_saved: "Το βίντεο τελετής αποθηκεύτηκε 🎬",
  tt_msg_video_saved: "Το βίντεο μηνύματος αποθηκεύτηκε 🎬",
  tt_video_saved_e: "Το βίντεο αποθηκεύτηκε 🎬",
  tt_video_deleted: "Το βίντεο διαγράφηκε",
  tt_video_too_big: "Πολύ μεγάλο βίντεο (μέγ. 200 MB)",
  tt_vault: "Τα δεδομένα σας αποθηκεύονται στο ψηφιακό χρηματοκιβώτιο, επεξεργάσιμα ανά πάσα στιγμή.",
  tt_action_fail: "Η ενέργεια απέτυχε",
};
const hi = {
  tt_cam_denied: "कैमरा एक्सेस अस्वीकृत या अनुपलब्ध",
  tt_add_guarantor: "पहले प्रकाशन चरण में कम से कम एक ज़मानतदार जोड़ें।",
  tt_no_video: "कोई वीडियो कैप्चर नहीं हुआ। कैमरा और माइक की अनुमति दें, फिर पुनः प्रयास करें (या वीडियो फ़ाइल आयात करें)।",
  tt_copy_fail: "कॉपी विफल",
  tt_cer_saved_full: "समारोह सहेजा गया ✓ (पाठ, गीत, तस्वीरें, संगीत)",
  tt_cer_saved: "समारोह सहेजा गया ✓",
  tt_dossier_unlocked: "फ़ाइल अनलॉक 🎉",
  tt_cam_unsupported: "यह ब्राउज़र कैमरा रिकॉर्डिंग समर्थित नहीं",
  tt_save_fail: "सहेजना विफल",
  tt_save_msg_first: "पहले संदेश सहेजें",
  tt_saved: "सहेजा गया",
  tt_mp3_mp4: "MP3 या MP4 फ़ाइल आवश्यक",
  tt_file_deleted: "फ़ाइल हटाई गई",
  tt_file_too_big20: "फ़ाइल बहुत बड़ी (अधिकतम 20 MB)",
  tt_video_required: "वीडियो फ़ाइल आवश्यक",
  tt_files_saved: "फ़ाइल सहेजी गई 📎",
  tt_unavailable: "यह सुविधा फ़िलहाल उपलब्ध नहीं।",
  tt_garants_off: "ज़मानतदार निष्क्रिय",
  tt_image_required: "छवि आवश्यक",
  tt_import_fail: "आयात विफल",
  tt_import_photo_fail: "फ़ोटो आयात विफल",
  tt_email_first: "पहले प्राप्तकर्ता का ईमेल दें",
  tt_email_indicate: "प्राप्तकर्ता का ईमेल दें",
  tt_link_dossier: "फ़ाइल लिंक कॉपी हुआ",
  tt_link_msg: "संदेश लिंक कॉपी हुआ",
  tt_link_garant: "ज़मानतदार लिंक कॉपी हुआ",
  tt_msg_deleted: "संदेश हटाया गया",
  tt_music_added: "संगीत जोड़ा गया 🎵",
  tt_msg_music_saved: "संदेश का संगीत सहेजा गया 🎵",
  tt_music_deleted: "संगीत हटाया गया",
  tt_music_too_big: "संगीत बहुत बड़ा (अधिकतम 20 MB)",
  tt_open_fail: "खोलना विफल",
  tt_photo_saved: "फ़ोटो सहेजी गई",
  tt_photo_too_big: "फ़ोटो बहुत बड़ी (अधिकतम 3 MB)",
  tt_delete_fail: "हटाना विफल",
  tt_cer_video_saved: "समारोह वीडियो सहेजा गया 🎬",
  tt_msg_video_saved: "संदेश वीडियो सहेजा गया 🎬",
  tt_video_saved_e: "वीडियो सहेजा गया 🎬",
  tt_video_deleted: "वीडियो हटाया गया",
  tt_video_too_big: "वीडियो बहुत बड़ा (अधिकतम 200 MB)",
  tt_vault: "आपका डेटा आपकी डिजिटल तिजोरी में सहेजा गया है, कभी भी बदला जा सकता है।",
  tt_action_fail: "क्रिया विफल",
};
const ja = {
  tt_cam_denied: "カメラへのアクセスが拒否または利用不可",
  tt_add_guarantor: "まず「公開」ステップで保証人を少なくとも1人追加してください。",
  tt_no_video: "動画が記録されませんでした。カメラとマイクを許可して再試行してください（または動画ファイルを読み込んでください）。",
  tt_copy_fail: "コピーできません",
  tt_cer_saved_full: "セレモニーを保存しました ✓（テキスト・曲・写真・音楽）",
  tt_cer_saved: "セレモニーを保存しました ✓",
  tt_dossier_unlocked: "ファイルのロック解除 🎉",
  tt_cam_unsupported: "このブラウザはカメラ録画に対応していません",
  tt_save_fail: "保存できません",
  tt_save_msg_first: "先にメッセージを保存してください",
  tt_saved: "保存しました",
  tt_mp3_mp4: "MP3 または MP4 ファイルが必要です",
  tt_file_deleted: "ファイルを削除しました",
  tt_file_too_big20: "ファイルが大きすぎます（最大20MB）",
  tt_video_required: "動画ファイルが必要です",
  tt_files_saved: "ファイルを保存しました 📎",
  tt_unavailable: "この機能は現在利用できません。",
  tt_garants_off: "保証人を無効化しました",
  tt_image_required: "画像が必要です",
  tt_import_fail: "読み込みできません",
  tt_import_photo_fail: "写真の読み込みができません",
  tt_email_first: "先に受取人のメールを入力してください",
  tt_email_indicate: "受取人のメールを入力してください",
  tt_link_dossier: "ファイルのリンクをコピーしました",
  tt_link_msg: "メッセージのリンクをコピーしました",
  tt_link_garant: "保証人のリンクをコピーしました",
  tt_msg_deleted: "メッセージを削除しました",
  tt_music_added: "音楽を追加しました 🎵",
  tt_msg_music_saved: "メッセージの音楽を保存しました 🎵",
  tt_music_deleted: "音楽を削除しました",
  tt_music_too_big: "音楽が大きすぎます（最大20MB）",
  tt_open_fail: "開けません",
  tt_photo_saved: "写真を保存しました",
  tt_photo_too_big: "写真が大きすぎます（最大3MB）",
  tt_delete_fail: "削除できません",
  tt_cer_video_saved: "セレモニー動画を保存しました 🎬",
  tt_msg_video_saved: "メッセージ動画を保存しました 🎬",
  tt_video_saved_e: "動画を保存しました 🎬",
  tt_video_deleted: "動画を削除しました",
  tt_video_too_big: "動画が大きすぎます（最大200MB）",
  tt_vault: "データはデジタル金庫に保存され、いつでも変更できます。",
  tt_action_fail: "操作できません",
};
const zh = {
  tt_cam_denied: "相机访问被拒绝或不可用",
  tt_add_guarantor: "请先在“发布”步骤中添加至少一位担保人。",
  tt_no_video: "未捕获到视频。请允许摄像头和麦克风后重试（或导入视频文件）。",
  tt_copy_fail: "复制失败",
  tt_cer_saved_full: "仪式已保存 ✓（文字、歌曲、照片、音乐）",
  tt_cer_saved: "仪式已保存 ✓",
  tt_dossier_unlocked: "档案已解锁 🎉",
  tt_cam_unsupported: "此浏览器不支持摄像头录制",
  tt_save_fail: "保存失败",
  tt_save_msg_first: "请先保存留言",
  tt_saved: "已保存",
  tt_mp3_mp4: "需要 MP3 或 MP4 文件",
  tt_file_deleted: "文件已删除",
  tt_file_too_big20: "文件过大（最大 20 MB）",
  tt_video_required: "需要视频文件",
  tt_files_saved: "文件已保存 📎",
  tt_unavailable: "该功能暂时不可用。",
  tt_garants_off: "担保人已停用",
  tt_image_required: "需要图片",
  tt_import_fail: "导入失败",
  tt_import_photo_fail: "照片导入失败",
  tt_email_first: "请先填写收件人邮箱",
  tt_email_indicate: "请填写收件人邮箱",
  tt_link_dossier: "档案链接已复制",
  tt_link_msg: "留言链接已复制",
  tt_link_garant: "担保人链接已复制",
  tt_msg_deleted: "留言已删除",
  tt_music_added: "已添加音乐 🎵",
  tt_msg_music_saved: "留言音乐已保存 🎵",
  tt_music_deleted: "音乐已删除",
  tt_music_too_big: "音乐过大（最大 20 MB）",
  tt_open_fail: "无法打开",
  tt_photo_saved: "照片已保存",
  tt_photo_too_big: "照片过大（最大 3 MB）",
  tt_delete_fail: "删除失败",
  tt_cer_video_saved: "仪式视频已保存 🎬",
  tt_msg_video_saved: "留言视频已保存 🎬",
  tt_video_saved_e: "视频已保存 🎬",
  tt_video_deleted: "视频已删除",
  tt_video_too_big: "视频过大（最大 200 MB）",
  tt_vault: "您的数据已存入数字保险库，随时可修改。",
  tt_action_fail: "操作失败",
};

export const postinity7 = { fr, en, es, es_mx: es, de, it, pl, fil, ru, el, hi, ja, zh };
